var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedEnterLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.512 14.4l4 3.764a.6.6 0 11-.823.874l-5.1-4.8a.6.6 0 010-.874l5.1-4.8a.6.6 0 11.823.874l-4 3.763H18a2.4 2.4 0 002.4-2.4V5.4a.6.6 0 111.2 0v5.4a3.6 3.6 0 01-3.6 3.6H4.512z",
    fill: "#fff"
  })));
}
export default SvgLedEnterLeft;